/** How fresh a page is: polled on a timer, streamed, or paused while the tab is hidden. */
import { cx } from '../cx'
import s from './LiveBadge.module.css'

export function LiveBadge({ mode, label }: { mode: 'poll' | 'stream' | 'paused' | 'reconnecting'; /** "every 15s"; defaults by mode. */ label?: string }) {
  const words = label ?? { poll: 'polling', stream: 'live', paused: 'paused', reconnecting: 'reconnecting' }[mode]
  return (
    <span className={cx(s.live, s[mode])} role="status">
      <i aria-hidden="true" />
      {words}
    </span>
  )
}
